import { CoolerCpu, Cpu, Gabinete, Mother } from '@core/services/CompatibilityHandler/model';

export const ComponentesObligatorios = {
  Cpu,
  Mother,
  CoolerCpu,
  Gabinete,
};
export const SubcatesObligatorias = [7, 49, 26, 48, 27, 36];
export const idsArmados = [4671, 5043];
export const idInstalarCCPU = 2615;
export const armadoccpusIncluido = [2094, 2093];
export const componentesObligatoriosSubcate = {
  cpu: [48, 27],
  mother: [49, 26],
  ccpu: [36],
  gab: [7],
};
